import {
  WithStyles,
  withStyles as withStylesCb,
  StyleRulesCallback
} from "@material-ui/core/styles";
import { BREADCRUMBS_HEIGHT, HERO_MIN_HEIGHT } from "./constants";

const styles: StyleRulesCallback = ({ spacing, breakpoints }) => ({
  contentWrapper: {
    display: "flex",
    minHeight: HERO_MIN_HEIGHT - BREADCRUMBS_HEIGHT
  },
  contentMain: {
    maxWidth: breakpoints.values.md,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
    paddingLeft: spacing.unit * 2,
    paddingRight: spacing.unit * 2,
    textAlign: "center",

    [breakpoints.up("md")]: {
      textAlign: "left"
    }
  },
  contentImage: {
    display: "none",
    marginLeft: spacing.unit * 4,
    [breakpoints.up("md")]: {
      display: "block"
    }
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
